"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FullWidthMarquee = FullWidthMarquee;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _fullWidthPanel = _interopRequireDefault(require("../common/full-width-panel.js"));
var _index = _interopRequireDefault(require("../../../navigation/header/secondary-nav/index.js"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _react2 = require("@linaria/react");
var _marqueeAttributedImage = _interopRequireDefault(require("../common/marquee-attributed-image.js"));
var _image = require("@site/pattern-library-core/image");
/* eslint-disable complexity */

const FullWidthMarqueeSection = /*#__PURE__*/(0, _react2.styled)("section")({
  name: "FullWidthMarqueeSection",
  class: "pl-f1vxwfew",
  vars: {
    "f1vxwfew-0": [({
      textAlign
    }) => textAlign === 'center' ? textAlign : `flex-${textAlign}`],
    "f1vxwfew-1": [({
      backgroundColor
    }) => backgroundColor ? backgroundColor : _intents.default.ux.box.backgroundColor],
    "f1vxwfew-2": [({
      portrait
    }) => portrait ? `url(${portrait})` : 'initial'],
    "f1vxwfew-3": [({
      portrait
    }) => portrait ? '32rem' : 'initial'],
    "f1vxwfew-6": [({
      tablet
    }) => tablet ? `url(${tablet})` : 'inherit'],
    "f1vxwfew-8": [({
      landscape
    }) => landscape ? `url(${landscape})` : 'inherit']
  }
});
const MarqueePanel = /*#__PURE__*/(0, _react2.styled)(_fullWidthPanel.default)({
  name: "MarqueePanel",
  class: "pl-m1nnv3a"
});

/**
 * Render full marquee.
 * @module FullWidthMarquee
 *
 * @param {Object} props React props
 * @param {String} props.layout Layout string. default|centered
 * @param {boolean} props.invert Invert Color Props
 * @param {boolean} props.isTransparentNav Transparent Nav
 * @param {Object} props.backgroundColor Background Color Props
 * @param {Object} props.portrait Mobile background image
 * @param {Object} props.tabletPortraitBackground Tablet portrait background image
 * @param {Object} props.tablet Tablet portrait background image
 * @param {Object} props.landscape Desktop background image
 * @param {Object} props.secondaryNav Secondary Navigation component
 * @param {Object} props.primaryPanel Full Width Marquee Panel component
 * @param {Object} props.secondaryPanel Full Width Marquee Panel component
 * @param {Object|React.ReactElement} props.priceLockup  Price Lockup component or React node
 * @returns {React.ReactElement} Full Marqueecomponent
 * @public
 */
function FullWidthMarquee({
  _name,
  invert = false,
  layout = 'default',
  backgroundColor,
  portrait,
  tabletPortraitBackground,
  tablet,
  landscape,
  primaryPanel,
  secondaryPanel,
  attributedImage,
  isTransparentNav,
  secondaryNav,
  partial,
  priceLockup
}) {
  const textAlign = layout && layout === 'centered' ? 'center' : 'start';
  const backgroundImages = {
    portrait: portrait?.url,
    tablet: tablet?.url || tabletPortraitBackground?.url || portrait?.url,
    landscape: landscape?.url
  };

  // eslint-disable-next-line react/prop-types
  const marqueePriceLockup = priceLockup || primaryPanel?.priceLockup;
  switch (layout) {
    case 'SSO':
    case 'formgroup':
    case 'marketingLeadForm':
    case 'racForm':
      return /*#__PURE__*/_react.default.createElement(FullWidthMarqueeSection, (0, _extends2.default)({
        "data-partial": partial || (invert ? 'dark1' : ''),
        backgroundColor: (0, _patternLibraryUtils.getBackgroundColor)(backgroundColor),
        textAlign: textAlign
      }, _patternLibraryUtils.tracking.create(_name), backgroundImages, {
        "data-cy": "full-width-marquee"
      }), secondaryNav && /*#__PURE__*/_react.default.createElement(_index.default, {
        invert: invert,
        isTransparent: isTransparentNav,
        secondaryNav: secondaryNav
      }), /*#__PURE__*/_react.default.createElement(MarqueePanel, {
        textAlign: textAlign,
        primaryPanel: primaryPanel,
        secondaryPanel: secondaryPanel,
        layout: layout,
        priceLockup: marqueePriceLockup
      }));
    case 'centered':
    default:
      return /*#__PURE__*/_react.default.createElement(FullWidthMarqueeSection, (0, _extends2.default)({
        "data-partial": partial || (invert ? 'dark1' : ''),
        backgroundColor: (0, _patternLibraryUtils.getBackgroundColor)(backgroundColor),
        textAlign: textAlign
      }, _patternLibraryUtils.tracking.create(_name), backgroundImages, {
        "data-cy": "full-width-marquee"
      }), secondaryNav && /*#__PURE__*/_react.default.createElement(_index.default, {
        invert: invert,
        isTransparent: isTransparentNav,
        secondaryNav: secondaryNav
      }), /*#__PURE__*/_react.default.createElement(MarqueePanel, {
        textAlign: textAlign,
        primaryPanel: primaryPanel,
        attributedImage: attributedImage,
        priceLockup: marqueePriceLockup
      }));
  }
}
FullWidthMarquee.propTypes = {
  _name: _propTypes.default.string,
  layout: _propTypes.default.oneOf(['default', 'centered', 'SSO', 'formgroup', 'racForm', 'marketingLeadForm']),
  invert: _propTypes.default.bool,
  backgroundColor: _propTypes.default.oneOfType([_propTypes.default.shape({
    rgb: _propTypes.default.string
  }), _propTypes.default.shape({
    intent: _propTypes.default.string
  })]),
  portrait: _propTypes.default.shape(_image.imgPropShape),
  tabletPortraitBackground: _propTypes.default.shape(_image.imgPropShape),
  tablet: _propTypes.default.shape(_image.imgPropShape),
  landscape: _propTypes.default.shape(_image.imgPropShape),
  secondaryNav: _propTypes.default.shape({
    ..._index.default.propTypes
  }),
  primaryPanel: _propTypes.default.shape({
    ..._fullWidthPanel.default.propTypes
  }).isRequired,
  secondaryPanel: _propTypes.default.shape({
    ..._fullWidthPanel.default.propTypes
  }),
  attributedImage: _propTypes.default.shape({
    ..._marqueeAttributedImage.default.propTypes
  }),
  isTransparentNav: _propTypes.default.bool,
  partial: _propTypes.default.string,
  priceLockup: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.node])
};
var _default = exports.default = FullWidthMarquee;